module.exports = __webpack_public_path__ + "img/recipientfees2.2016777d.png";